<template>
    <div>
        <br />
        <file-summaries
            v-bind:response="files_response"
            v-bind:hasMore="has_more"
            v-on:loadMore="onLoadMore"
        />

    </div>
</template>
<script>
import FileSummaries from "@/components/files/FileSummaries";
import { getInstance } from '../../auth';
const PortalApi = require("@brightoncromwell/portal-api");
const rfqsApiInstance = new PortalApi.RfqsApi();
let defaultClient = PortalApi.ApiClient.instance;


export default {
    setup() {
        
    },

    components: {
        'file-summaries': FileSummaries,
    },

    created(){
        this.getFiles();
    },

    mounted(){
    },

    data (){
        return {
            files_response: [],
            limit: 10,
            offset: 0,
        }
    },

    methods: {
        createResponse: function(files) {
        return files.items.map(item => ({
            file_name: item.file_name.split('_').slice(2).join(''),
            attachment_id: item.attachment_id,
            upload_date: item.upload_date
        }));
    },
        
        getFiles: async function () {
            const token = await this.getToken();
            let company_id = localStorage.getItem('selected_company_id');
            let limit = this.limit + this.offset;
            let BearerAuth = defaultClient.authentications['BearerAuth'];
            BearerAuth.accessToken = token;
            rfqsApiInstance.rfqsCompanyCompanyIdFilesGet(company_id, limit, (error, data, response) => {
                if (error) {
                    console.error(error);
                } else {
                    const files = this.createResponse(data);
                    this.has_more = !(files.length < this.limit);
                    this.files_response = this.files_response.concat(files);
                }
            });
        },
        // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function(){
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false){
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              instance.getTokenSilently().then(authToken => {resolve(authToken);}).catch(error => {
              if(error == "login_required"){
                  window.location.href = "/signin";
                }
              reject(error);
              });
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated){
              window.location.href = "/signin";
            }
          });
        }
      });
    },

    onLoadMore: function() {
      this.offset = this.offset + 10;
      this.files_response = [];
      this.getFiles();
    }

    }
}

</script>
